import { useFormContext, useDependedFieldsValueControl } from '@sravni/cosago-react-library/lib/hooks';

import { useAppDispatch } from 'shared/lib';

import { setCarInfoStatus } from 'entities/pledgeAutoForm';

import { useGetEnginePowers, useGetManufactureYears, useGetModels } from '../model/pledgeAutoForm.query';
import type { TPledgeAutoFields } from '../types';

export function usePledgeAutoFieldsControl() {
  const { watch } = useFormContext<TPledgeAutoFields>();

  const carBrandValue = watch('carBrand');
  const carModelValue = watch('carModel');
  const carYearValue = watch('carManufactureYear');
  const carNumber = watch('carNumber');
  const dispatch = useAppDispatch();

  const [loadModels] = useGetModels();
  const [loadManufactureYears] = useGetManufactureYears();
  const [loadEngines] = useGetEnginePowers();

  const handleLoadEngines = () => {
    carBrandValue?.value &&
      carModelValue?.value &&
      carYearValue?.value &&
      loadEngines({
        brandId: carBrandValue.value,
        modelId: carModelValue.value,
        year: carYearValue.value,
      });
  };

  useDependedFieldsValueControl<TPledgeAutoFields>({
    fieldName: 'carNumber',
    onValueChangeAction: [() => carNumber && dispatch(setCarInfoStatus('initial'))],
  });

  useDependedFieldsValueControl<TPledgeAutoFields>({
    fieldName: 'carBrand',
    onValueChangeAction: [() => carBrandValue?.value && loadModels(carBrandValue.value)],
    fieldsToResetOnChangeValue: ['carModel', 'carManufactureYear', 'enginePower'],
  });

  useDependedFieldsValueControl<TPledgeAutoFields>({
    fieldName: 'carModel',
    onValueChangeAction: [() => carModelValue?.value && loadManufactureYears(carModelValue.value)],
    fieldsToResetOnChangeValue: ['carManufactureYear', 'enginePower'],
  });

  useDependedFieldsValueControl<TPledgeAutoFields>({
    fieldName: 'carManufactureYear',
    onValueChangeAction: [handleLoadEngines],
    fieldsToResetOnChangeValue: ['enginePower'],
  });
}
